import React, { useState, useEffect, useRef } from "react";
import fetch from "cross-fetch";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { Paper } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { RepeatOneSharp } from "@mui/icons-material";
import Header from "../../../Shared/Header/Default/Herader";
import XeroxHeader from "../../../Shared/Header/Xerox/XeroxHeader";
import DefaultFooter from "../../../Shared/Footer/Default/Footer";
import XeroxFooter from "../../../Shared/Footer/Xerox/XeroxFooter";
import { useCookies } from "react-cookie";
import LoadingSpinner from "../../Controls/LoadingSpinner/LoadingSpinner";
import "babel-polyfill";
import { Translations } from "../../../Shared/Translation/Translations";
import LoadingXeroxSpinner from "../../Controls/LoadingSpinner/XeroxLoadingSpinner";
import "./Code.css";
import img1 from "../../../assets/images/Xerox/check2.png";
import check from "../../../assets/images/Rpost/check.png";
import email from "../../../assets/images/Xerox/email.png";
import pwd from "../../../assets/images/Xerox/pwdcode.png";
import ReCAPTCHA from "react-google-recaptcha";
import PersonalInfo from "../../../Shared/PersonalInfo/PersonalInfo.js";
const Container = styled.div({
  paddingTop: "120px",
  textAlign: "center",
  margin: "0 auto",
});

const SubmitButton = styled(Button)({
  width: "120px",
  margin: "0 auto",
});

const FormContainer = styled(Paper)({
  width: "400px",
  height: "280px",
  padding: "40px 40px 20px 40px",
  margin: "0 auto",
});

const MessageContainer = styled(Paper)({
  padding: "20px",
});

const EmailInput = styled(TextField)({
  width: "300px",
  margin: "0 auto",
});

let ipAddress = 0;
const Code = (props) => {
  const [rpd, setRpd] = useState({
    id: "",
    email: "",
    recipientId: "",
    data: "",
    ip: "",
    userSessionId: "",
    firstName: "",
    lastName: "",
  });
  const [openPersonalInfo, setIsOpenPersonalInfo] = useState(false);
  const SITE_KEY = process.env.REACT_APP_reCAPTCHA_SITE_KEY;
  const SECRET_KEY = process.env.REACT_APP_reCAPTCHA_SECRET_KEY;
  const captchaRef = useRef(null);
  const [GoogleCaptchaSiteKey, setGoogleCaptchaSiteKey] = useState(
    "6Leo5RcjAAAAAC8azoEhkoOJcDWsxRvIZXnkqHQF"
  );
  const [verifyEmail, setVerifyEmail] = useState("");
  const [getCodeEmail, setGetCodeEmail] = useState("");
  const [passcode, setPasscode] = useState("");
  const [message, setMessage] = useState("");
  const [messageCode, setMessageCode] = useState("");
  const [screen, setScreen] = useState(4); //1:Enter your email address and the passcode,2:Get Passcode,3:Check your email
  const { documentId } = useParams();
  const history = useNavigate();
  const [senderEmilAddress, setSenderEmilAddress] = useState("");
  const { typeId } = useParams();
  const { level } = useParams();
  const { fileName } = useParams();
  const [modelopen, setOpen] = useState(false);
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [modelMessage, setModelMessage] = useState(
    Reader_UserVerificationFailure
  );
  const [cookies, setCookie] = useCookies(["RPDUserSession"]);

  const [name, setName] = useState("");
  const [isDisplayVerifyCode, setisDisplayVerifyCode] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [languageTranslations, setLanguageTranslations] = [];
  const [openReaderNotes, setOpenReaderNotes] = useState(false);
  const [openRequestSucess, setOpenRequestSucess] = useState(false);
  const [readerNotes, setReaderNotes] = useState("");
  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [
    Reader_EnterYourEmailAddressXerox,
    setReader_EnterYourEmailAddressXerox,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [Reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");

  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");
  const [Reader_YourDocumentadressAcess, setReader_YourDocumentadressAcess] =
    useState("");
  const [Reader_ReadMore, setReader_ReadMore] = useState("");
  const [Reader_InternetConnectProblem, setReader_InternetConnectProblem] =
    useState("");
  const [
    Reader_ConnectivityReauthenticate,
    setReader_ConnectivityReauthenticate,
  ] = useState("");
  const [PasscodeType, setPasscodeType] = useState("password");
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [Reader_BotInfoMessage, setReader_BotInfoMessage] = useState("");
  const [Reader_BlockMessage, setReader_BlockMessage] = useState("");
  const [Reader_robot, setReader_robot] = useState("");
  const [Reader_BotVerifiedMessage, setReader_BotVerifiedMessage] =
    useState("");
  const [Reader_Botverified, setReader_Botverified] = useState("");
  const [noInternetImg, setnoInternetImg] = useState(
    "iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAclBMVEX///8AAADx8fHh4eGWlpb29vYNDQ08PDzW1taenp5TU1O7u7umpqZmZmZtbW0gICAaGhooKCg0NDTQ0NDq6urJyclERETe3t6xsbFNTU1bW1t3d3eGhoZoaGguLi6srKyAgIATExPBwcGMjIyCgoJBQUF9nMxXAAAJhklEQVR4nO2d6XqqMBCGEcR9qYi7dan2/m/xqKckE0hCJmRRnnw/gRrehsxMJlsUNVO6Gk5PXx0L6n31D5Ok4es11nJmgw0qOw588u1s87203/gCPDjhe+oQ++BLFs4AH/LwqQ5c8j00dg24cQzY6QzdAubOAR3XYnxiCz/tRua1Ljd0l22R9RLzTWqllDQfM+a6586i7tn/7dxiyTFkPNgrh1XZD9okfBjtKy3Jkevvlk2AXcIo75OSplYLKrStGDnLhFHs1tisKoDWCUF0cbNcUsQPZawTRpeiqJ7tkqIENPtD5oww77myNSnw9Ovo5IwwIt1Q27EbtWqdLI0W7gh/imL3dssBnv6aRy4JSRx8slrMhQK+2oNDwmhelGWzEOjpV88LLgmLNn+1WMYZAG5fV1wSFhagZyfIfwp6+j+D1i5C6Okvf9daRUhdLgh/20SYzingjlxtEyHr6Qu1iHAKGmFOL7eHEPbpYeTbGsKKpy/UFsKqpy/UEsIfANhlb7WDkOfpC7WCEGbvv8s320CYguHrXeVuGwh/KSCnY9YCQuDpr3n19ucTijx9oY8nFHr6Qp9OCD09f3By/tmE0BF2+Y8Ut/vGChXLAmFWB5gSO1T1I+ZlnhA2wn7GEch+H00VKpFxwrSD0NJQoTIZJxwiAF00Q/OEmMmGXE9iWqYJlwhAF63QPOFRHdDN0LpxwtGb1aBxwngupaLKnLTBpwwTJgRh/iXUqX9z4Sb+ZItwlsZCGSlJWbYIBQGpBwVCpAKhBwVCpAKhBwVCpAKhBwVCpAKhBwVCpBCEP/epEdX1NX0RpqXVM00kXxDji9DoKlLpFG5PhIbX6L0hoeF1pLLEiCfCRPCqmpIV5Ykw7QveVUujNyREZf9rxZkL4Z8w2qxN8e2lgF5jGnFGFaO6UkLUhlQg9KBAiFQg9KBAiFQg9KBAiFQg9KBAiFQg9KBAiFQg9KBAiFQg9KBAiBSCMB6Mjahu2z5vhHBxVDMtft6S0Bxgp2ZhiifC+GqSULp9kCdCw9u0yl4+EFoijHuCd9WSdD89X5YGswCsVtK1G968hUHErbQgjx7/Z2JEq3f1+M4UCJEKhB4UCJEKhB4UCJEKhB4UCJEKhB4UCJEKhB4UCJEKhB4UCJEKhB7kkTCtFNmu1Qj59+lrzwyLbXdaqf7sIof0Rfg3NAM2jrzp4L30JUX0RViUS4ptshBKeoSM79V5pBL1q7DzlqvzyArLSXGl0bJZ2dou36tkycBY5dQ5jGRF+WqHfwdN0b0hm6wMlhbmbbX6a/nhHGyjPNYGlG9P6M/jnw+zIVNocpvqHDp6qTlHNURtSAVCZ4o3q+Fh9r0f7a9tJFx2dwUXkJlzj9+AcCmOHfYGIH0Txl35Bqq9Y9KwBL+E+U2h/3VoxuiVUDXwOzSxOR4JV6ob/D501i/GHyGub1Kz04REvgg3mYyHJ/nUabE8EVbPw+70b+dV/mpw+XLb/a0+oPmGfgjL8xy/DqtK6mZ5L1dz5YwmJXkhLO0DvxsLMlOrb/ZBrROCfRCyNmYtm06bsIzSvYlEP+GekElhfdXFZQmz8Y9GLbonnMA3Pir4cuYP5JvZ8eScEB7Fq+gBGM8yqX+elWtCOOf/pOzF4Y6G2B3+XROCVrVGRJvgnHD5kEBVjgmBI8QdrAQcDLIpuiUEOdYM+acz3e/ULSFtTwv0kRL0MBXcoesIwvFxhtahC60JOOh0gOSLonRB/hhlT9Vz3uoH0rACHoGaGbTNj+Bw3hzTI3awQyupReoK9Y5vo9ZGusOrJmGDcRjyy3T7TNYRDs68QyUf77YtLSAiSQFMJTrYofVQ+QmmrMHz4Lp+lTF+mqUeE/XQdozIMjrYobU4J4p47Su0o/HfxbLpyeec66QhIz5z9Dg+XkXviBzwdoO/S/wc6+Xy4uk1vEpbsnraRplQ+zMtPlL6iTGukPoAiJjT8JV5C/J/VjfGiB1a9zqzZ/okD0iMMZuMoIQAMQcH+jFPk54UU7WGCB8usdEEKPLvZ7tM0AsVbS4HmVS2xVFzoPyZOovaqLthrzNHaP6vxfzKof4TycEpHwPnjJDsyTAr3WC6xE/EHLaG8pJh8pneIkU5IyQBSSVBzyAOogQm+ytroknoppyUckZIuhXVBsTMHxsD08Nb9F3cOqmGNc4IC+vIG7sWTZHjrWonR/eqmhpnhEU5XDO/KrMJAWmEoDqq6IqQmNKyofkvHiJ/XwIy5qhqTF0Rkp1DLvz71Q9VsPECMaaqwbcrQkIgOq+1XIuinSXIqJXqoKkrwp/aclZXCCisITKbTrUX7IpwXFtOzgx6C/M4b0tI6lAUiySluF6UMiSx0bt9paQd3vn3q1kSAeLbWhpiS/kZ64QzL4P/oZKs+bt5C9KF4MaTOfeAdy4i6W3xs1dVOY9pFpyordwGZR+qftSm3BvR1K/4zZj+IDNCzEEsbuEjb61ZAAiRr6tiIXK2u1TqTJVE0kXKvSdiw05NEWpELEQ5qGFq8BnJMAFcuRaJKVUeY6PjHY0Z5CLGtLxXGzQy/0M1phZLHzUZPVGfIqXxJ1qKCQn75cF2V8SiEJHNzFG3qZ4wJb0R2w1xWhTE2jQwC4EG2xCReZp8pIhGRTdExE4BQIpOZWOsIDUzsDcB2iLzIyStj3FupCHqDXkpi35gTERJ8jdsd4nUYsa9qtzDf4qOyom6boa05770hgtIYRjnMuL+RJ1iQqg1MqsuOnDBVOK2CvLSoFf5Gpeabwqsmd1aJLHZlWmJ+fmy5c5bGB8nbPBJE424eQ5wmtIIP4NAXXQrYvzstKfoZBxsEM1MjftWHhDAiz+SpiqwDS560ndpFsJ61h3a0ARM50BPpwG9Cp3GZOzwRmXhXROdFKWz5Cvm9kCtip8ZFgvYQ63FUDFnbrxl4ayN9pQ/KqNnNhtHhOuHtNeWDI3uZ62iqXJ7AtNLm6xKjI/Cd7GkTK06Yjil7qIP+FB+cF2PKmndFXyp5t2Dwe3XqV0d1XUS8hl8XH2SiUxxstkMbIqdx3mXfaoxu0TxpBEoeNGeee3ORZTczUv7p3wMYBSV1jN1+udqRabbXekpM5+oI90rDTK7nwd5/PIfab4ZH6uBpN7SNW/ibxuyyNajdf/EvWe3e25BCZ9DpKvNjqstYY6TEIw6vruSaT3aSzvVkbT301JliUPfcjbesgb7Gj7pEtPPUD4RZxiybtNdMd5EyWR2reJNh59oP8XKfyb3XX9x7fTm2fowqT1/jqt/jWyPyzE4vWwAAAAASUVORK5CYII="
  );
  const [blockImg, setblockImg] = useState(
    "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"
  );
  const [allowedCountryCodeFlag, setAllowedCountryCodeFlag] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [Reader_ClickGetPasscode, setReader_ClickGetPasscode] = useState("");
  const [Reader_AuthenticatingPleaseWait, setReader_AuthenticatingPleaseWait] =
    useState("");

  const [
    Reader_RequestingPassCodePleaseWait,
    setReader_RequestingPassCodePleaseWait,
  ] = useState("");
  const [
    Reader_ReplyToDocumentPleaseWait,
    setReader_ReplyToDocumentPleaseWait,
  ] = useState("");
  const [Reader_PrintDocumentPleaseWait, setReader_PrintDocumentPleaseWait] =
    useState("");
  const [
    Reader_NavigatingBnPagesPleaseWait,
    setReader_NavigatingBnPagesPleaseWait,
  ] = useState("");
  const [Reader_RequestAccess, setReader_RequestAccess] = useState("");
  const [Email_RequestHasBeenSent, setEmail_RequestHasBeenSent] = useState("");
  const [Email_PleaseWaitForApproval, setEmail_PleaseWaitForApproval] =
    useState("");
  const [Email_NoteOptional, setEmail_NoteOptional] = useState("");
  const [docSenderAddress, setDocSenderAddress] = useState("");

  const [Loadingmessage, setLoadingmessage] = useState(0);
  useEffect(() => {}, [screen]);
  useEffect(() => {}, [getCodeEmail]);
  useEffect(() => {
    window.addEventListener("online", () => setOnlineStatus(true));
    window.addEventListener("offline", () => setOnlineStatus(false));
  }, []);
  //const [ip, setIpaddress] = useState("");
  const [isBlock, setisBlock] = useState(false);
  useEffect(() => {
    if (ipAddress == 0) {
      getipAddress(0);
    } else {
      getipAddress(1);

      let defaultscreen = localStorage.getItem("defaultScreen");
      if (defaultscreen == "1") {
        setisDisplayVerifyCode(true);
        getLanguageTranslations();
        localStorage.setItem("defaultScreen", "");
      }
    }
    //console.log("Translations.Reader_DocumentID" + Translations);
  });

  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      window.history.go(1);
    });
  }, []);

  async function getipAddress(flag) {
    console.warn("when getipAddress called " + new Date());
    const url = `${process.env.REACT_APP_API}/getipaddressipapi`;
    //const url = `https://ipapi.co/json/?key=NgWXDrKNEEu8T7HecS6tOAsDnfKWnAQgFCYucqV0JvWx5H1WQ1`;
    let json;
    try {
      //setOpenLoader(true);
      var res = await fetch(url);
      json = await res.json();
      json = json.ipAddressDetails;
      //console.log(json.ip);
      console.warn("when getipAddress response " + new Date());
      var countryCode =
        json.country_code != null
          ? json.country_code.toString().toLowerCase()
          : "";
      var regionCode =
        json.region_code != null
          ? json.region_code.toString().toLowerCase()
          : "";
      if (
        countryCode === "ch" ||
        countryCode === "al" ||
        countryCode === "ad" ||
        countryCode === "at" ||
        countryCode === "by" ||
        countryCode === "be" ||
        countryCode === "ba" ||
        countryCode === "bg" ||
        countryCode === "hr" ||
        countryCode === "cy" ||
        countryCode === "cz" ||
        countryCode === "dk" ||
        countryCode === "ee" ||
        countryCode === "fi" ||
        countryCode === "fr" ||
        countryCode === "de" ||
        countryCode === "gr" ||
        countryCode === "hu" ||
        countryCode === "is" ||
        countryCode === "ie" ||
        countryCode === "it" ||
        countryCode === "xk" ||
        countryCode === "lv" ||
        countryCode === "li" ||
        countryCode === "lt" ||
        countryCode === "lu" ||
        countryCode === "mt" ||
        countryCode === "md" ||
        countryCode === "mc" ||
        countryCode === "me" ||
        countryCode === "nl" ||
        countryCode === "mk" ||
        countryCode === "no" ||
        countryCode === "pl" ||
        countryCode === "pt" ||
        countryCode === "ro" ||
        countryCode === "ru" ||
        countryCode === "sm" ||
        countryCode === "rs" ||
        countryCode === "sk" ||
        countryCode === "si" ||
        countryCode === "se" ||
        countryCode === "se" ||
        countryCode === "ch" ||
        countryCode === "ua" ||
        countryCode === "gb" ||
        countryCode === "va" ||
        countryCode === "gb-eng" ||
        countryCode === "gb-sct" ||
        countryCode === "gb-wls" ||
        countryCode === "gb-nir" ||
        (countryCode === "us" && regionCode === "ca")
      )
        setAllowedCountryCodeFlag(true);
      if (flag == 0) {
        ipAddress = json.ip;
        localStorage.setItem("TypeId", "");
        localStorage.setItem("TypeId", typeId);

        getLanguageTranslations();

        let localuserSessionId = localStorage.getItem("local_" + documentId);
        CheckisBlocked(localuserSessionId);
        if (level == "1") {
          let usercookieId = "";
          setOpenLoader(false);
          checkUserSession(usercookieId);
        } else if (document.cookie.indexOf(`${documentId}=`) != -1) {
          let usercookieId = getCookie(documentId);
          if (usercookieId != null && usercookieId != "") {
            setOpenLoader(false);
            checkUserSession(usercookieId);
          } else {
            setOpenLoader(false);
            setisDisplayVerifyCode(true);
          }
        } else if (localuserSessionId != "" && localuserSessionId != null) {
          setOpenLoader(false);
          checkUserSession(localuserSessionId);
        } else {
          setOpenLoader(false);
          setisDisplayVerifyCode(true);
        }
      }
    } catch (error) {
      console.log(error);
      setOpenLoader(false);
      return () => {};
    }
  }

  const CheckisBlocked = async (usercookieId) => {
    console.warn("when ValidateReaderAuthorization called " + new Date());
    setOpenLoader(true);
    let browserName = getBrowserName();
    const url = `${process.env.REACT_APP_API}/docs/ValidateReaderAuthorization/${documentId}`;
    let result;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "",
        code: "",
        ip: ipAddress,
        UserSessionId: usercookieId,
        userBrowser: browserName,
      }),
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        console.warn(
          "when ValidateReaderAuthorization responded " + new Date()
        );
        if (response !== null) {
          if (response) {
            setisBlock(response);
            setScreen(4);
          } else {
            setisBlock(response);
            setScreen(1);
          }
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log(error);
      });
  };
  async function getLanguageTranslations() {
    console.warn("when language translations called " + new Date());
    const browserlanguage = window.navigator.language;
    const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
    let json;
    try {
      setOpenLoader(true);
      var res = await fetch(url);
      json = await res.json();
      console.warn("when language translations responded " + new Date());
      //console.log(json);
      //setLanguageTranslations(json.data);
      json.data.forEach((element) => {
        if (element.id === "2AC6EFF9-AF8B-4D36-8ABC-0A24B1C56F56")
          setReader_DocumentID(element.description);
        else if (element.id === "9BA629FE-2BA0-4740-89DC-167FCD3CA4C4")
          setReader_EmailAdress(element.description);
        else if (element.id === "3B344AE3-080C-4DFF-B17F-177BCB8D6A15")
          setReader_VerificationCode(element.description);
        else if (element.id === "8CA84CC8-46EE-4009-8EE0-1A9E11571EC8")
          setReader_VerificationCode_Header(element.description);
        else if (element.id === "F07FC5A9-C71D-4E63-911D-255E1544F3EB")
          setReader_Authorize(element.description);
        else if (element.id === "A4598B68-CC37-4B4D-9502-2A839C2C4865")
          setReader_VerificationCode_Message(element.description);
        else if (element.id === "7E85F861-F0E2-4BEC-92C4-2AEFF225FD6D")
          setReader_ClickHere(element.description);
        else if (element.id === "BF02D851-9481-4215-8EDD-2C4F1D1A14F5")
          setReader_AuthorizeFailure(element.description);
        else if (element.id === "B9272BCA-CFE7-4AA6-A530-30F2CC8377C2")
          setReader_GetVerificationCode(element.description);
        else if (element.id === "ECFD0FAA-B485-4499-9966-3A60FAB1ACE5")
          setReader_VerificationCode_Instruction(element.description);
        else if (element.id === "21E54828-A57B-4935-BBD5-40F08BD6F130")
          setReader_VerificationCode_Remember(element.description);
        else if (element.id === "BF69DF0D-8FF5-4555-AEC6-447F223E3AD6")
          setReader_PleaseGoBack(element.description);
        else if (element.id === "998BBBEF-9B6E-437A-80DC-56621DCED16D")
          setReader_Submit(element.description);
        else if (element.id === "5C20C8C9-C580-43A4-9E18-577A1F4E431C")
          setReader_ActualSize(element.description);
        else if (element.id === "8BCEBAA5-21F8-4D04-89D4-5A76836CB327")
          setReader_FitPage(element.description);
        else if (element.id === "294EBBB5-D0FA-42B8-B3AD-5F549463AAFD")
          setReader_FullWidth(element.description);
        else if (element.id === "BFE1787E-D04C-494C-A9E5-62496FA3FE08")
          setReader_DistributionList(element.description);
        else if (element.id === "AA313936-D9D9-408B-BBDB-6A8CE6CABB08")
          setReader_SideNote(element.description);
        else if (element.id === "7F73F129-096E-4BBA-B731-7A189872F835")
          setReader_ReplyToOwner(element.description);
        else if (element.id === "326A65C1-89D3-4554-ADAD-7B7E9B08E42C")
          setReader_Print(element.description);
        else if (element.id === "2FDC29C8-1A0D-4EED-9385-7F8CDFBB6A0F")
          setReader_Zoom(element.description);
        else if (element.id === "AE91A15B-35AF-480E-9250-8A65A062A596")
          setReader_EnterYourEmailAddress(element.description);
        else if (element.id === "B0C2990F-CDE0-45BE-B7DC-8C9B52338536")
          setReader_Email(element.description);
        else if (element.id === "6AB42951-6546-44B6-9750-C94B8BC3FA95")
          setReader_Passcode(element.description);
        else if (element.id === "442CE6A9-22AF-408A-A2AA-92EE577999A7")
          setReader_OK(element.description);
        else if (element.id === "B6785E69-9416-47A2-BDFA-9537E6A60591")
          setReader_Getpasscode(element.description);
        else if (element.id === "7754F0CA-053D-4203-9261-9A8D4BE56746")
          setReader_GetPasscode(element.description);
        else if (element.id === "818E8449-D5EE-4820-A646-9AC8D1D4F984")
          setReader_EnterYourEmailAddressCode(element.description);
        else if (element.id === "73D789E4-518B-41E5-AB1D-29FB252C960D")
          setReader_EnterYourEmailAddressXerox(element.description);
        else if (element.id === "DC458BAF-A9A8-403A-913A-A7C7C417A578")
          setReader_Cancel(element.description);
        else if (element.id === "434DDE98-2BB2-4A7C-82DE-AB6D6DEE9E7B")
          setReader_DocumentExpired(element.description);
        else if (element.id === "BBB2A9AA-0CBB-4175-B827-AC3FAF91B20C")
          setReader_FailedVerifyCodeEmail(element.description);
        else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
          setReader_Continue(element.description);
        else if (element.id === "A43B773D-45DD-4968-809E-AE3271A639B3")
          setReader_GeneralTermsFooter(element.description);
        else if (element.id === "C920E4EB-129F-4EDC-BE19-B1CA133E0A19")
          setReader_GeneralTerms(element.description);
        else if (element.id === "674C0F1F-6EA4-443A-BD38-B47030C2ADA9")
          setReader_Patent(element.description);
        else if (element.id === "6F6B09DC-D705-4F70-A5AD-BA539115C23F")
          setReader_CheckYourEmail(element.description);
        else if (element.id === "1E0B6C7D-24EB-4697-8F00-CB3B3EECC1EE")
          setReader_APasscodeEmailed(element.description);
        else if (element.id === "809D3F1D-D2E6-475D-BEAB-CE7A6795C147")
          setReader_AVerificationCodeEmailed(element.description);
        else if (element.id === "3387D8D0-BDDB-4FA5-BE71-DBADEC20A0D4")
          setReader_TryAgain(element.description);
        else if (element.id === "AD9099E6-C2C1-480E-96F4-DC148642A783")
          setReader_DocumentRestrictedAccess(element.description);
        else if (element.id === "D22EFEBA-D89A-49E8-B544-DF728B2EC62C")
          setReader_ReachedMaximumViews(element.description);
        else if (element.id === "0FCF576E-DB5C-4246-B05F-E88215C69731")
          setReader_DocumentIsNoLongerAvailable(element.description);
        else if (element.id === "697A33A8-5735-4064-9866-E95832CC8303")
          setReader_InactivityYourSessionWillEnd(element.description);
        else if (element.id === "33903FCD-2591-469E-8891-E9B6F0746E3B")
          setReader_Minutes(element.description);
        else if (element.id === "12BCE010-F096-41B5-AE4F-EA98B2310538")
          setReader_Seconds(element.description);
        else if (element.id === "F84C536A-E172-4C14-B827-F06DC17E31D0")
          setReader_SessionTimedOut(element.description);
        else if (element.id === "1A9D7565-3DEB-4AF1-A60E-F5B08F62C834")
          setReader_YouHaveBeenInactive(element.description);
        else if (element.id === "817258A6-5338-4508-8733-F6437E942CBD")
          setReader_ContinueReadingDocument(element.description);
        else if (element.id === "FFDF3914-4CC6-4C02-A6D2-FC05F2A375F7")
          setReader_PrintingDocumentIsNotPermitted(element.description);
        else if (element.id === "27FF1441-6850-4601-B2DD-075D3AD01AEE")
          setReader_ConfirmYourVote(element.description);
        else if (element.id === "771A386D-B1F0-485C-B448-1D340209D580")
          setReader_OnlyVoteOnce(element.description);
        else if (element.id === "3341B4F5-4B0F-4BB1-A04F-46CFB98C803F")
          setReader_Like(element.description);
        else if (element.id === "CA3DB143-B23C-4351-B635-5E636C37664C")
          setReader_Dislike(element.description);
        else if (element.id === "E06FF01E-F57C-4337-94E5-986B31AB1D41")
          setReader_Voting(element.description);
        else if (element.id === "E9D32EC4-BFC1-49E0-9A11-5657B5AD4987")
          setReader_ProtectedDocumentAccess(element.description);
        else if (element.id === "007CF6B5-9AED-4956-A5E8-2D27F40795F9")
          setReader_ProtectedDocument(element.description);
        else if (element.id === "EEC944B7-CF89-4073-AAB2-38C5CD4C388C")
          setReader_AllRightsReserved(element.description);
        else if (element.id === "53708ED8-B8C6-4246-AB81-76F49FAC7E1C")
          setReader_Terms(element.description);
        else if (element.id === "AB232AED-8FB4-4E72-A550-DC57477EA1BE")
          setReader_DocumentServerUnavailable(element.description);
        else if (element.id === "977B4401-07E3-4848-870E-D7519A89BE0A")
          setReader_InternetConnectionRequired(element.description);
        else if (element.id === "A46D6AA3-7989-468F-85FE-AA9CA637A63A")
          setReader_EnteredEmailIsNotReadersList(element.description);
        else if (element.id === "D4FE0525-1829-48FE-87F7-D248053B5BF8")
          setReader_FailedSendVerifyCode(element.description);
        else if (element.id === "A399DFA9-C65E-40CC-A51B-7D3825270DB6")
          setReader_UserVerificationFailure(element.description);
        else if (element.id === "01464BDE-1F06-4CE4-B382-0D12FD415573")
          setReader_DocName(element.description);
        else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
          setReader_ID(element.description);
        else if (element.id === "B1B1DD59-8DE0-4F34-914D-3BC9BF7C549A")
          setReader_EnterEmailGetPasscode(element.description);
        else if (element.id === "4D24E110-C95C-44DC-8DE0-586EEFD43901")
          setReader_PleaseEnterSubject(element.description);
        else if (element.id === "55F7F90F-5079-44D9-80C6-75E5CA0F3D8E")
          setReader_EmailSuccessfullySent(element.description);
        else if (element.id === "2B5CD1B8-E2C1-40FE-8657-81297F664F97")
          setReader_DigitalRightsManagement(element.description);
        else if (element.id === "384088DF-3A77-4AE7-9B85-2349394EFC30")
          setReader_ProtectedDocumentViewer(element.description);
        else if (element.id === "BCE385E2-E768-479E-8A28-7D90B153347E")
          setReader_ViewDistributionList(element.description);
        else if (element.id === "549961D1-C11B-4EF6-BFFC-8DC5BB995463")
          setReader_UsersList(element.description);
        else if (element.id === "F4CE40B3-2391-4A0B-BBB9-930710845A68")
          setReader_ViewSideNote(element.description);
        else if (element.id === "56B9CC7C-747E-420E-A5ED-B3F1C0A73D3B")
          setReader_NoteFrom(element.description);
        else if (element.id === "F8109066-3DEF-4FD3-A4A3-C6170D9D1CF8")
          setReader_ReplyToDocument(element.description);
        else if (element.id === "3C7C0F84-FC5E-416A-9E6B-110606DBE2DF")
          setReader_ClickToPrint(element.description);
        else if (element.id === "BA8DC442-BB68-4D4F-978F-64DE3B71D467")
          setReader_Send(element.description);
        else if (element.id === "EF11C8AF-E646-493F-9016-583861FF6008")
          setReader_Message(element.description);
        else if (element.id === "C1988359-42CB-41A2-8336-C7767AAE9406")
          setReader_Subject(element.description);
        else if (element.id === "4E086CF8-AAD1-4717-8CA4-E3C22EFC6256")
          setReader_ToAddress(element.description);
        else if (element.id === "39265EFF-9C1B-49D3-98BA-7110FA4AEB62")
          setReader_YouWillLoggedIn(element.description);
        else if (element.id === "CCC0FADA-9CD5-4BFD-BAEB-7EE9B9677DF1")
          setReader_ClickToVote(element.description);
        else if (element.id === "3D2F2837-9063-40CB-AF53-5E7790373EA1")
          setReader_DocumentHasNoAccess(element.description);
        else if (element.id === "0F8665A9-F7F3-4D07-8F64-E0F0576079D0")
          setReader_AccessDocument(element.description);
        else if (element.id === "F99602CF-AF87-4DE1-A20B-E82A064F1B51")
          setReader_SessionExpiredAccessDocument(element.description);
        else if (element.id === "8B569962-71C7-48A6-BDD0-43C37B489D91")
          setReader_PleaseTryAgain(element.description);
        else if (element.id === "5CA9B16D-46A7-43E9-9B3D-9076CB4C18B9")
          setReader_CheckYourConnection(element.description);
        else if (element.id === "C24DB5B6-951E-4E47-AEE1-A401FE85A7C3")
          setReader_LegalNotices(element.description);
        else if (element.id === "511A78A4-02CB-4EF0-A05C-3A8FC1EB92A7")
          setReader_ClickServiceLevelTerms(element.description);
        else if (element.id === "0C6DC977-FFCA-45BD-83DA-CD11AC5B7E6B")
          setReader_OtherService(element.description);
        else if (element.id === "57061912-dd57-46f2-8f39-3b01a75b2fd6")
          setReader_YourDocumentadressAcess(element.description);
        else if (element.id === "67732020-983b-49d8-bc69-f27790bf009e")
          setReader_ReadMore(element.description);
        else if (element.id === "4ddea558-4a3f-43b8-bdb2-d69df1c2162c")
          setReader_BotInfoMessage(element.description);
        else if (element.id === "47dd41f8-d61f-42ad-a0be-38195c694d01")
          setReader_robot(element.description);
        else if (element.id === "4d9606ee-3ddd-46cb-8444-b656e4b217ad")
          setReader_Botverified(element.description);
        else if (element.id === "d46741cd-dc5d-4ba5-984f-2c4dec6989dd")
          setReader_BotVerifiedMessage(element.description);
        else if (element.id === "6B574532-AAD2-4356-86FC-5C2F27E90FFE")
          setReader_InternetConnectProblem(element.description);
        else if (element.id === "555ADB9D-8867-4455-8BB7-85EA9BA0C2BB")
          setReader_ConnectivityReauthenticate(element.description);
        else if (element.id === "a6bcc85d-c1b3-43c8-8424-4db0dc30ce18")
          setReader_ClickGetPasscode(element.description);
        else if (element.id === "ad4c892f-dd09-44e7-893a-09e59cfa22b5")
          setReader_BlockMessage(element.description);
        else if (element.id === "73243072-681e-41af-b4dc-bfe19afb7631") {
          setReader_AuthenticatingPleaseWait(element.description);
        } else if (element.id === "29d0e16e-63e2-4e15-999b-1d6843f5cc50") {
          setReader_RequestingPassCodePleaseWait(element.description);
        } else if (element.id === "30fcbad0-5163-4163-846a-6be2110781ce") {
          setReader_ReplyToDocumentPleaseWait(element.description);
        } else if (element.id === "9fee0ab5-c17f-4fc2-a5c2-b943069f442d") {
          setReader_PrintDocumentPleaseWait(element.description);
        } else if (element.id === "088dcf20-c3a7-489d-83c1-9a6b8030dc21") {
          setReader_NavigatingBnPagesPleaseWait(element.description);
        } else if (element.id === "fbe73c6d-d78c-48f7-aea0-686f67e636d4") {
          setReader_RequestAccess(element.description);
        } else if (element.id === "7c559ae0-d90c-4d3a-96c6-206e0d36fc93") {
          setEmail_RequestHasBeenSent(element.description);
        } else if (element.id === "6be3bcc2-0efb-4aa8-8c85-655e153f0c1d") {
          setEmail_PleaseWaitForApproval(element.description);
        } else if (element.id === "15b1a3a0-b5ee-4a65-989c-b9b156097f89") {
          setEmail_NoteOptional(element.description);
        }
      });
    } catch (error) {
      setOpenLoader(false);
      console.log(error);
      return () => {};
    }
  }

  const checkUserSession = async (usercookieId) => {
    console.warn("when verify/ called " + new Date());
    setOpenLoader(true);
    let browserName = getBrowserName();
    const url = `${process.env.REACT_APP_API}/docs/verify/${documentId}`;
    let result;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "",
        code: "",
        ip: ipAddress,
        UserSessionId: usercookieId,
        userBrowser: browserName,
      }),
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        console.warn("when verify/ responded " + new Date());
        if (
          response &&
          response.recipientId !== "" &&
          response.recipientId !== null
        ) {
          localStorage.setItem("local_" + documentId, response.userSessionId);
          setCookie(documentId, response.userSessionId);
          sessionStorage.setItem(
            "session_" + documentId,
            response.userSessionId
          );
          read(verifyEmail, response.recipientId, usercookieId);
        } else if (response.level1Authenticated) {
          localStorage.setItem("local_" + documentId, response.userSessionId);
          setCookie(documentId, response.userSessionId);
          sessionStorage.setItem(
            "session_" + documentId,
            response.userSessionId
          );
          console.log(documentId);
          //history(response.redirectUrl,"_self");
          window.open(response.redirectUrl, "_self");
        } else if (response.authenticated) {
          setOpenLoader(false);
          localStorage.setItem(
            "ContinentCode_" + documentId,
            response.continentCode
          );
          localStorage.setItem(
            "RecipientEmail_" + documentId,
            response.recipientEmail
          );
          localStorage.setItem("RecipientIp_" + documentId, response.readerIp);
          localStorage.setItem("Network_" + documentId, response.network);
          localStorage.setItem("Location_" + documentId, response.location);
          localStorage.setItem("UserAgent_" + documentId, response.userAgent);
          if (response.message != null && response.message === "declined") {
            localStorage.setItem("DeclinedVar_"+documentId, "true");
          } else {
            localStorage.setItem("DeclinedVar_"+documentId, "false");
          }

          window.open(response.redirectUrl, "_self");
        } else if (response.sessionAuthenticated) {
          setOpenLoader(false);
          console.log(response.sessionAuthenticated);
          setisDisplayVerifyCode(true);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        setisDisplayVerifyCode(true);
        console.log(error);
        setMessage(Reader_FailedSendVerifyCode + " ");
      });
  };
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }
  function handleGetCodeEmail(event) {
    //console.log(event.target.value);
    setGetCodeEmail(event.target.value.trim());
  }
  function handleVerifyEmail(event) {
    //console.log(2);
    setVerifyEmail(event.target.value);
  }
  function handlePasscode(event) {
    //console.log(3);
    setPasscode(event.target.value);
  }

  const handleClick = async (event) => {
    event.preventDefault();
    // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(getCodeEmail)) {
    if (getCodeEmail != null && getCodeEmail != "") {
      await getCode(getCodeEmail);
    }
    // else{
    //   setOpen(true);
    //   setModelMessage("Please enter the email address.");
    // }
  };
  const handleKeyUp = async (event) => {
    if (event.target.value.trim() === "") setButtonDisabled(true);
    else setButtonDisabled(false);
  };
  const getCode = async (getCodeEmail) => {
    const browserlanguage = window.navigator.language;
    const url = `${
      process.env.REACT_APP_API
    }/docs/code/${documentId}/?email=${encodeURIComponent(
      getCodeEmail
    )}&browserlanguage=${browserlanguage}&securitylevel=${encodeURIComponent(
      level
    )}`;
    let result;
    setLoadingmessage(2);
    setOpenLoader(true);
    fetch(url, { mode: "cors" })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        console.log(response.status);

        if (response && response.authenticated) {
          console.log(response.status);
          setScreen(3);
          setMessage(Reader_APasscodeEmailed + " ");
          setOpenLoader(false);
          setMessageCode("");
        } else if (
          response &&
          !response.authenticated &&
          response.errorMessage != null
        ) {
          console.log(response.status);
          setOpen(true);
          setModelMessage(response.errorMessage);
          setMessage(response.errorMessage);
          setMessageCode(response.messageCode);
          setOpenLoader(false);
        } else if (
          response &&
          !response.authenticated &&
          !response.redirectUrl != null
        ) {
          localStorage.setItem("FileName", response.fileName);
          localStorage.setItem("url", response.redirectUrl);
          localStorage.setItem("documentId", documentId);
          //history(response.redirectUrl);
          window.open(response.redirectUrl, "_self");
        } else if (response && !response.authenticated) {
          console.log(response.status);
          setOpen(true);
          setModelMessage(response.errorMessage);
          setMessage(response.errorMessage);
          setOpenLoader(false);
        } else {
          console.log(response.status);
          setOpen(true);
          setModelMessage(Reader_EnteredEmailIsNotReadersList);
          setMessage(Reader_FailedSendVerifyCode);
          setOpenLoader(false);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log(error);
        setMessage(Reader_FailedSendVerifyCode);
      });
  };
  const verifyCode = async () => {
    console.warn("when verify/ called " + new Date());
    let browserName = getBrowserName();
    console.log(`${process.env.REACT_APP_API}`);
    const url = `${process.env.REACT_APP_API}/docs/verify/${documentId}`;
    setLoadingmessage(1);
    setOpenLoader(true);
    let result;
    const requestOptions = {
      mode: "cors",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: verifyEmail,
        code: passcode,
        ip: ipAddress,
        userBrowser: browserName,
      }),
    };
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        console.warn("when verify/ responded " + new Date());
        console.log(response);
        console.log(response.status);

        if (response && !response.authenticated) {
          if (response.isBlocked) {
            setisBlock(true);
            setScreen(4);
          } else {
            setOpen(true);
            setModelMessage(Reader_UserVerificationFailure);
          }
          setOpenLoader(false);
        } else if (
          response &&
          response.recipientId !== "" &&
          response.recipientId !== null
        ) {
          console.log(response.status);
          console.log(response.recipientId);
          localStorage.setItem("local_" + documentId, response.userSessionId);
          setCookie(documentId, response.userSessionId);
          sessionStorage.setItem(
            "session_" + documentId,
            response.userSessionId
          );
          if (
            (response.firstName === "" || response.firstName === null) &&
            (response.lastName === "" || response.lastName === null) &&
            typeId !== "1"
          ) {
            setOpenLoader(false);

            setIsOpenPersonalInfo(true);
            setRpd({
              id: documentId,
              email: verifyEmail,
              recipientId: response.recipientId,
              data: "",
              ip: ipAddress,
              userSessionId: response.userSessionId,
            });
            console.log(screen);
          } else {
            read(verifyEmail, response.recipientId, response.userSessionId);
          }

          //history(`/read/${documentId}/${response.recipientId}`);
        } else if (
          response &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          localStorage.setItem("FileName", response.fileName);
          localStorage.setItem("url", response.redirectUrl);
          localStorage.setItem("documentId", documentId);
          localStorage.setItem(
            "ContinentCode_" + documentId,
            response.continentCode
          );
          localStorage.setItem(
            "RecipientEmail_" + documentId,
            response.recipientEmail
          );
          localStorage.setItem("RecipientIp_" + documentId, response.readerIp);
          localStorage.setItem("Network_" + documentId, response.network);
          localStorage.setItem("Location_" + documentId, response.location);
          localStorage.setItem("UserAgent_" + documentId, response.userAgent);
          //window.open(response.url, "_self");
          //history(`/Xerox/ExpireMessage/${documentId}`);
          //history(response.redirectUrl);
          if (response.message != null && response.message === "declined") {
            localStorage.setItem("DeclinedVar_"+documentId, "true");
          } else {
            localStorage.setItem("DeclinedVar_"+documentId, "false");
          }

          window.open(response.redirectUrl, "_self");
        } else {
          setOpenLoader(false);
          console.log(response.status);
          setMessage(Reader_FailedSendVerifyCode);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log(error);
        setMessage(Reader_FailedSendVerifyCode);
      });
  };
  const read = (email, recipientId, userCookieId) => {
    var url = `${process.env.REACT_APP_API}/docs/read/${documentId}`;
    var rpdInfo = {
      id: documentId,
      email: email,
      recipientId: recipientId,
      data: "",
      ip: ipAddress,
      userSessionId: userCookieId,
    };

    setOpenLoader(true);
    fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        if (response.authenticated) {
          setOpenLoader(false);
          console.log(documentId);
          console.log(response.recipientId);
          setCookie(
            documentId,
            response.recipientId,
            response.sessionExpireDate
          );

          window.open(response.redirectUrl, "_self");
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log("Document read error");
      });
  };
  const handleToClose = () => {
    setOpenLoader(false);
    setPasscode("");
    setVerifyEmail("");
    setOpen(false);
  };

  const getPassCodeClick = () => {
    setScreen(2);
    setGetCodeEmail("");
    setButtonDisabled(true);
  };
  const handleRequestAccess = () => {
    setOpenReaderNotes(true);
  };
  const handleRequestAccessSucess = () => {
    setOpenRequestSucess(false);
    setReaderNotes("");
  };
  function handlerOpenNotesClosed() {
    setOpenReaderNotes(false);
    setReaderNotes("");
  }
  const handleToContinue = () => {
    var url = `${process.env.REACT_APP_API}/docs/requestaccess`;
    var rpdInfo = {
      id: documentId,
      email: getCodeEmail,
      readerNotes: readerNotes.trim(),
    };

    setOpenLoader(true);
    fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.emailSent == true) {
          setDocSenderAddress(response.senderAddress);
          setOpenRequestSucess(true);
          setOpenLoader(false);
          setOpenReaderNotes(false);
          setPasscode("");
          setVerifyEmail("");
          setOpen(false);
        }
        else if (response.sucess =="false" && response.redirectUrl != null)
        {
          setOpen(false);
          window.open(response.redirectUrl, "_self");
        }
          setOpen(false);
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log("Document read error");
      });
  };
  const getVerifyScreen = () => {
    setPasscode("");
    if (screen === 3) setVerifyEmail(getCodeEmail);
    else setVerifyEmail("");
    setScreen(1);
  };

  const recaptchaCallback = () => {};

  const togglePassword = () => {
    if (PasscodeType === "password") {
      setPasscodeType("text");
      return;
    }
    setPasscodeType("password");
  };

  return (
    <>
      {onlineStatus === false && (
        <div
          className="rpdFont modal"
          id="PagewModel"
          style={{ display: "block", backgroundColor: "#54404061" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="mb3" style={{ textAlign: "center" }}>
                  <img
                    src={`data:image/png;base64,${noInternetImg}`}
                    className="h-100px"
                  />
                </div>
                <h5
                  className={
                    typeId === "1"
                      ? "text-center noInternetPadding res-font14 RobotoFont"
                      : "text-center noInternetPadding res-font14 rpdFont rd-text"
                  }
                >
                  {Reader_InternetConnectProblem +
                    " " +
                    Reader_ConnectivityReauthenticate}
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}
      {openLoader ? (
        typeId === "1" ? (
          <LoadingXeroxSpinner />
        ) : Loadingmessage == 1 ? (
          <LoadingSpinner authenticatingMsg={Reader_AuthenticatingPleaseWait} />
        ) : Loadingmessage == 2 ? (
          <LoadingSpinner
            authenticatingMsg={Reader_RequestingPassCodePleaseWait}
          />
        ) : (
          <LoadingSpinner
            authenticatingMsg={Reader_NavigatingBnPagesPleaseWait}
          />
        )
      ) : null}
      {/* <div>
            <Container>
                <FormContainer elevation={3}>
                    <Stack spacing={2} justifyContent="center" alignItems="center">
                        <EmailInput id="email" label="Enter email" variant="outlined" onChange={handleChange} />
                        <SubmitButton variant="contained" onClick={handleClick}>Submit</SubmitButton>
                        {message && <MessageContainer elevation={2}>{message}</MessageContainer>}
                    </Stack>
                </FormContainer>  
            </Container>
        </div>
        <div className="modal-body">
        <div className="d-flex justify-content-center mb-3" style={{color: "#000"}} >
          <p className="text-center font-1rem" >Enter your email address to get a passcode for .</p>
        </div> */}

      {typeId === "1" ? (
        <XeroxHeader
          Reader_ProtectedDocument={Reader_ProtectedDocument}
        ></XeroxHeader>
      ) : (
        <Header
          Reader_ProtectedDocumentAccess={Reader_ProtectedDocumentAccess}
        ></Header>
      )}
      {typeId === "1" ? (
        <main className="RobotoFont xerox-signin">
          {screen === 1 && (
            <div
              id="verify"
              style={{ display: isDisplayVerifyCode ? "block" : "none" }}
            >
              <div className="RobotoFont xerox_card login-padding">
                <div
                  className="RobotoFont d-flex justify-content-center mb-3"
                  style={{ color: "#040921" }}
                >
                  <p className="text-center mt-1 xerox-text font-18px w-100 res-font14">
                    {Reader_EnterYourEmailAddressXerox}:
                    <span className="xerox-wordbreak">
                      {" "}
                      {fileName.split(".").slice(0, -1).join(".")}
                    </span>
                  </p>
                </div>
                <div className="d-flex flex-column justify-content-center">
                  <div className="RobotoFont input-group xerox-group mb-2 pb-2">
                    <div className="input-group-append">
                      <span className="input-group-text xerox-group-text">
                        <img
                          src={email}
                          alt=""
                          className="icon-img"
                          draggable="false"
                        ></img>
                        {/* <i className="material-icons" style={{ fontSize: "22px" }}>
                      mail
                    </i> */}
                      </span>
                    </div>
                    <input
                      type="text"
                      className="RobotoFont form-control input_user"
                      placeholder={Reader_Email}
                      value={verifyEmail}
                      onChange={(e) => handleVerifyEmail(e)}
                      autoComplete="new-password"
                    ></input>
                  </div>
                  <div className="RobotoFont input-group xerox-group mb-3">
                    <div className="RobotoFont input-group-append">
                      <span className="input-group-text xerox-group-text">
                        <img
                          src={pwd}
                          alt=""
                          className="icicon-img"
                          draggable="false"
                        ></img>
                        {/* <i className="material-icons" style={{ fontSize: "22px" }}>
                      key
                    </i> */}
                      </span>
                    </div>
                    <input
                      type={PasscodeType}
                      className="RobotoFont form-control input_pass"
                      placeholder={Reader_Passcode}
                      value={passcode}
                      onChange={(e) => handlePasscode(e)}
                      autoComplete="new-password"
                    ></input>
                    <div className="input-group-btn">
                      <a onClick={togglePassword} style={{ cursor: "pointer" }}>
                        {PasscodeType === "password" ? (
                          <span
                            className="material-icons passwordShow"
                            style={{ color: "#0a4148" }}
                          >
                            visibility_off
                          </span>
                        ) : (
                          <span
                            className="material-icons passwordShow"
                            style={{ color: "#0a4148" }}
                          >
                            remove_red_eye
                          </span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="RobotoFont input-group mb-3">
                <div className="RobotoFont input-group-append">
                <ReCAPTCHA className="recaptcha" sitekey={process.env.REACT_APP_reCAPTCHA_SITE_KEY} ref={captchaRef} />
                  </div>
              </div> */}
                <div className="RobotoFont d-flex justify-content-center mt-3 ">
                  <button
                    type="button"
                    name="button"
                    className="RobotoFont btn login_btn w-100"
                    style={{ lineHeight: "1.6" }}
                    onClick={(e) => verifyCode()}
                  >
                    {Reader_OK}
                  </button>
                </div>
                <div className="RobotoFont d-flex justify-content-center links flex-wrap text-wrap mt-3">
                  <p className="getCode xerox-text" onClick={getPassCodeClick}>
                    {Reader_GetPasscode}
                  </p>
                </div>
                {allowedCountryCodeFlag && (
                  <p className="xeroxemail-text">
                    {Reader_YourDocumentadressAcess}
                    <a
                      className="xeroxreade-more"
                      href="https://rpost.com/legal-notices/privacy-notice-rdocs-supplement"
                      target="_blank"
                    >
                      <i>{Reader_ReadMore}</i>{" "}
                    </a>
                  </p>
                )}
              </div>
            </div>
          )}

          {screen === 2 && (
            <div
              className="RobotoFont xerox_card login-padding"
              id="divPassCode"
            >
              <h4 className="RobotoFont text-center mb-3 xerox-text">
                {Reader_GetPasscode}
              </h4>
              <div className="RobotoFont d-flex flex-column justify-content-start mb-3 flex-dir xerox-text">
                <p className="RobotoFont text-center font-18px text-md-nowrap text-sm-wrap mb-0">
                  {Reader_EnterYourEmailAddressCode}{" "}
                  {fileName.split(".").slice(0, -1).join(".")}
                </p>
                {/* <p className="RobotoFont text-center mt-0 font-1rem text-md-nowrap text-sm-wrap ps-1">
                  {Reader_ID} {documentId}.
                </p> */}
              </div>
              <div className="RobotoFont input-group xerox-group mb-3 pb-2">
                <div className="RobotoFont input-group-append">
                  <span className="input-group-text xerox-group-text">
                    <img
                      src={email}
                      alt=""
                      className="icon-img"
                      draggable="false"
                    ></img>
                  </span>
                </div>
                <input
                  id="email"
                  type="text"
                  className="RobotoFont form-control input_user"
                  placeholder={Reader_Email}
                  onKeyUp={(e) => handleKeyUp(e)}
                  value={getCodeEmail}
                  //onChange={alert(1)}
                  onChange={(e) => handleGetCodeEmail(e)}
                ></input>
              </div>

              <div className="d-flex justify-content-center pt-1 mb-3 ">
                <button
                  type="button"
                  className="RobotoFont w-50 btn btn-outline-secondary me-3 px-4 px-md-5 cpy-1"
                  style={{ border: "1px solid #040921" }}
                  onClick={getVerifyScreen}
                >
                  {Reader_Cancel}
                </button>
                <button
                  type="button"
                  className="RobotoFont w-50 btn btn-secondary cpx-5 cpy-1 xerox-bg"
                  style={{
                    backgroundColor: "#040921 !important",
                    color: "white !important",
                    border: "1px solid #040921",
                  }}
                  onClick={handleClick}
                  disabled={isButtonDisabled}
                >
                  {Reader_OK}
                </button>
              </div>
            </div>
          )}

          {screen === 3 && (
            <div
              className="RobotoFont user_card login-padding"
              id="emailsuccess"
            >
              <div className="d-flex justify-content-center">
                <img src={img1} alt="" className="check mb-3"></img>
              </div>

              <h4 className="RobotoFont text-center mb-3 xerox-text">
                {Reader_CheckYourEmail}
              </h4>
              <div
                className="d-flex justify-content-center mb-3 "
                style={{ color: "#000" }}
              >
                <p className="text-center font-1rem text-nowrap1">
                  {message} <br></br>{" "}
                  <div className="text-wrap-custom"> {getCodeEmail}</div>
                </p>
              </div>
              <div className="d-flex justify-content-center login_container">
                <button
                  type="button"
                  className="RobotoFont btn login_btn w-100"
                  style={{ lineHeight: "1.6" }}
                  onClick={getVerifyScreen}
                >
                  {Reader_OK}
                </button>
              </div>
            </div>
          )}
          {screen === 4 && isBlock === true && (
            <div className="RobotoFont user_card login-padding">
              <div className="d-flex justify-content-center">
                <img
                  src={`data:image/png;base64,${blockImg}`}
                  alt=""
                  className="check mb-3"
                ></img>
              </div>
              <div
                className="d-flex justify-content-center mb-3 "
                style={{ color: "#000" }}
              >
                <p className="text-center font-1rem text-nowrap1">
                  {Reader_BlockMessage}
                </p>
              </div>
            </div>
          )}
        </main>
      ) : (
        <main className="rpdFont form-signin ">
          {openPersonalInfo && (
            <div
              className="rpdFont modal"
              id="PagewModel"
              style={{ display: "block", backgroundColor: "#54404061" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <div className="modal-dialog modal-dialog-centered modal-customelg">
                <div className="modal-content">
                  <div className="modal-body mt-4">
                    <PersonalInfo rpdInfo={rpd} documentId={documentId} />
                  </div>
                </div>
              </div>
            </div>
          )}
          {screen === 1 && (
            <div
              className="rpdFont user_card r-login-padding"
              id="verify"
              style={{ display: isDisplayVerifyCode ? "block" : "none" }}
            >
              <div
                className="rpdFont d-flex flex-column justify-content-center"
                style={{ color: "#040921" }}
              >
                <p className="text-center mb-0 mt-1 font-18px res-font14 fontBold">
                  {Reader_EnterYourEmailAddress}
                </p>
                <p className="text-center font-18px wordbreak res-font14">
                  {Reader_DocName} {fileName}
                </p>
              </div>
              <div className="rpdFont d-flex justify-content-center links flex-wrap text-wrap ">
                <p
                  className="getCode1"
                  title="Click here to get a passcode to access the document."
                  onClick={getPassCodeClick}
                  style={{
                    backgroundColor: "#ffff00",
                    padding: "2px 6px 2px 6px",
                  }}
                >
                  {Reader_ClickGetPasscode}
                </p>
              </div>
              <div className="rpdFont input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rp-text">
                    <i
                      className="material-icons"
                      style={{ fontSize: "22px", color: "#ffff" }}
                    >
                      mail
                    </i>
                  </span>
                </div>
                <input
                  type="text"
                  className="rpdFont form-control input_user"
                  placeholder={Reader_Email}
                  value={verifyEmail}
                  onChange={(e) => handleVerifyEmail(e)}
                  autoComplete="new-password"
                ></input>
              </div>
              <div className="rpdFont input-group mb-3">
                <div className="input-group-append">
                  <span className="input-group-text rp-text">
                    <i
                      className="material-icons"
                      style={{ fontSize: "22px", color: "#ffff" }}
                    >
                      key
                    </i>
                  </span>
                </div>
                <input
                  type={PasscodeType}
                  className="rpdFont form-control input_pass"
                  placeholder={Reader_Passcode}
                  value={passcode}
                  onChange={(e) => handlePasscode(e)}
                  autoComplete="new-password"
                ></input>
                <div className="input-group-btn">
                  <a onClick={togglePassword} style={{ cursor: "pointer" }}>
                    {PasscodeType === "password" ? (
                      <span className="material-icons passwordShow">
                        visibility_off
                      </span>
                    ) : (
                      <span className="material-icons passwordShow">
                        remove_red_eye
                      </span>
                    )}
                  </a>
                </div>
              </div>
              {/* <div className="rpdFont input-group mb-3">
                <div className="rpdFont input-group-append">
                <ReCAPTCHA className="recaptcha" sitekey={process.env.REACT_APP_reCAPTCHA_SITE_KEY} ref={captchaRef} />
                  </div>
              </div> */}

              <div className="rpdFont d-flex justify-content-center mt-3 pt-1 login_container">
                <button
                  type="button"
                  name="button"
                  className="rpdFont btn login_btn w-md-75 rp-btn"
                  style={{ lineHeight: "1.6", fontSize: "17px" }}
                  onClick={(e) => verifyCode()}
                >
                  {Reader_Authorize}
                </button>
              </div>
              <div className="rpdFont">
                {allowedCountryCodeFlag && (
                  <p className="email-text">
                    {Reader_YourDocumentadressAcess}
                    <a
                      className="reade-more"
                      href="https://rpost.com/legal-notices/privacy-notice-rdocs-supplement"
                      target="_blank"
                    >
                      <i>{Reader_ReadMore}</i>{" "}
                    </a>
                  </p>
                )}
                <p className="rpdFont mb-0 doc-id">
                  {Reader_ID} {documentId}
                </p>
              </div>
            </div>
          )}

          {screen === 2 && (
            <div className="rpdFont user_card r-login-padding" id="divPassCode">
              <h4
                className="modal-title text-center mb-3 rd-text"
                style={{ fontWeight: "500" }}
              >
                {Reader_GetPasscode}
              </h4>
              <div className="rpdFont d-flex  flex-column justify-content-start mb-3 rd-text flex-dir">
                <p className="text-center font-18px text-md-nowrap text-sm-wrap mb-0 fontBold">
                  {Reader_EnterYourEmailAddressCode}
                </p>
                <p className="text-center font-18px wordbreak">{fileName}</p>
              </div>
              <div className="input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rp-text">
                    <i
                      className="material-icons"
                      style={{ fontSize: "22px", color: "#ffff" }}
                    >
                      mail
                    </i>
                  </span>
                </div>
                <input
                  id="email"
                  type="text"
                  className="rpdFont form-control input_user"
                  onKeyUp={(e) => handleKeyUp(e)}
                  placeholder={Reader_Email}
                  value={getCodeEmail}
                  //onChange={alert(1)}
                  onChange={(e) => handleGetCodeEmail(e)}
                ></input>
              </div>

              <div className="rpdFont d-flex justify-content-center pt-1 mb-3 login_container">
                <button
                  type="button"
                  className="rpdFont w-50 btn btn-outline-secondary me-3 px-4 px-md-5 cpy-1"
                  style={{ border: "1px solid #040921" }}
                  onClick={getVerifyScreen}
                >
                  {Reader_Cancel}
                </button>
                <button
                  type="button"
                  className="rpdFont w-50 btn btn-secondary cpx-5 cpy-1 rp-btn"
                  style={{
                    backgroundColor: "#040921 !important",
                    color: "white !important",
                    border: "1px solid #040921",
                  }}
                  disabled={isButtonDisabled}
                  onClick={handleClick}
                >
                  {Reader_OK}
                </button>
              </div>
              <div
                className="rpdFont mt-2"
                style={{
                  fontStyle: "italic",
                  fontFamily: "Calibri",
                  fontSize: "9pt",
                  color: "#7F7F7F",
                  textAlign: "center",
                  marginBottom: "-25px",
                }}
              >
                {Reader_ID} {documentId}
              </div>
            </div>
          )}

          {screen === 3 && (
            <div
              className="rpdFont user_card r-login-padding"
              id="emailsuccess"
            >
              <div className="d-flex justify-content-center">
                <img src={check} alt="" className="check mb-3"></img>
              </div>

              <h4 className="rpdFont modal-title text-center mb-3 rd-text">
                {Reader_CheckYourEmail}
              </h4>
              <div
                className="d-flex justify-content-center mb-3 rd-text"
                style={{ color: "#000" }}
              >
                <p className="rpdFont text-center font-1rem text-nowrap1">
                  {message} <br></br>{" "}
                  <div className="text-wrap-custom"> {getCodeEmail}</div>
                </p>
              </div>
              <div className="rpdFont d-flex justify-content-center login_container">
                <button
                  type="button"
                  className="rpdFont btn login_btn w-sm-100 w-md-50 rp-btn"
                  style={{ lineHeight: "1.6" }}
                  onClick={getVerifyScreen}
                >
                  {Reader_OK}
                </button>
              </div>
            </div>
          )}
          {isBlock === true && screen === 4 && (
            <div class="user_card">
              <div class="rpdFont d-flex justify-content-center">
                <img
                  src={`data:image/png;base64,${blockImg}`}
                  alt=""
                  className="check mb-3"
                ></img>
              </div>
              <div class="d-flex flex-column justify-content-center mb-3">
                <p class="rpdFont text-center font-1rem text-nowrap1 rd-text">
                  {Reader_BlockMessage}
                </p>
              </div>
            </div>
          )}
        </main>
      )}

      {typeId === "1" ? (
        <div className="text-end document-id">
          <label className="text-end font-8">
            {Reader_ID} {documentId}
          </label>
        </div>
      ) : (
        <div></div>
      )}

      {typeId === "1" ? (
        <XeroxFooter
          Reader_AllRightsReserved={Reader_AllRightsReserved}
          Reader_Terms={Reader_Terms}
        ></XeroxFooter>
      ) : (
        <DefaultFooter
          Reader_GeneralTermsFooter={Reader_GeneralTermsFooter}
          Reader_LegalNotices={Reader_LegalNotices}
          Reader_ClickServiceLevelTerms={Reader_ClickServiceLevelTerms}
          Reader_Patent={Reader_Patent}
          Reader_OtherService={Reader_OtherService}
        ></DefaultFooter>
      )}
      {modelopen === true && (
        <div
          className="modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body" style={{ padding: "0.9rem" }}>
                <h5
                  className={
                    typeId === "1"
                      ? "text-center my-4 res-font14 RobotoFont xerox-text"
                      : "text-center my-4 res-font14 rpdFont rd-text"
                  }
                >
                  <span class="text-warn-text text-wrap-custom">
                    {modelMessage}
                  </span>
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: typeId === "1" ? "#0a4148" : "#040921",
                    }}
                    onClick={handleToClose}
                  >
                    {Reader_OK}
                  </button>
                  {messageCode == "RPD001" && (
                    <button
                      type="button"
                      className="btn btn-secondary w-50 py-2 ms-3"
                      data-bs-dismiss="modal"
                      style={{
                        background: typeId === "1" ? "#0a4148" : "#040921",
                      }}
                      onClick={handleRequestAccess}
                    >
                      {Reader_RequestAccess}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openReaderNotes === true && (
        <div
          className="modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#54404061" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content" style={{ marginTop: "5%" }}>
              <div className="modal-header pb-1">
                <h4
                  className="d-flex align-items-center text-danger fw-bold "
                  htmlFor=""
                >
                  Note
                </h4>
                <button
                  type="button"
                  className="btn modalclose download"
                  style={{ color: "#dc3545" }}
                  onClick={(e) => handlerOpenNotesClosed()}
                >
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="modal-body mb-1 justify-content-center d-flex">
                <textarea
                  name="ReaderNotes"
                  draggable="false"
                  style={{ resize: "none", width: "95%" }}
                  placeholder="Optional"
                  rows="5"
                  maxlength="255"
                  value={readerNotes}
                  onChange={(e) => setReaderNotes(e.target.value)}
                ></textarea>
              </div>
              <div className="mb-2 justify-content-center d-flex">
                <button
                  type="button"
                  className="btn btn-secondary py-2 p-3"
                  data-bs-dismiss="modal"
                  style={{
                    background: typeId === "1" ? "#0a4148" : "#040921",
                  }}
                  onClick={handleToContinue}
                >
                  {Reader_Continue}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openRequestSucess === true && (
        <div
          className="modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#54404061" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="justify-content-center d-flex">
                <div
                  className="rpdFont user_card r-login-padding"
                  id="emailsuccess"
                >
                  <div className="d-flex justify-content-center">
                    <img src={check} alt="" className="check mb-3"></img>
                  </div>
                  <div
                    className="d-flex justify-content-center mb-3 rd-text"
                    style={{ color: "#000" }}
                  >
                    <p className="rpdFont text-center font-1rem text-nowrap1">
                      {Email_RequestHasBeenSent}:
                      <span class="text-warn-text text-wrap-custom">
                        {" "}
                        {docSenderAddress}
                      </span>{" "}
                      <br></br>{" "}
                      <div className="text-wrap-custom">
                        {" "}
                        {Email_PleaseWaitForApproval}
                      </div>
                    </p>
                  </div>
                  <div className="rpdFont d-flex justify-content-center login_container">
                    <button
                      type="button"
                      className="rpdFont btn login_btn w-sm-100 w-md-50 rp-btn"
                      style={{ lineHeight: "1.6" }}
                      onClick={handleRequestAccessSucess}
                    >
                      {Reader_OK}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Code;
